import { createFileRoute, useRouter } from "@tanstack/react-router";
import {
  BookPage,
  BookPageHeaderLinks,
  validateBookSearch,
  type BookSearch,
} from "@/components/BookPage";
import { bookHead, BOOK_T } from "@/lib/book-i18n";

export const Route = createFileRoute("/book/")({
  validateSearch: validateBookSearch,
  head: () => bookHead("en"),
  component: EnBookPage,
  errorComponent: ({ error, reset }) => {
    const router = useRouter();
    const t = BOOK_T.en;
    return (
      <div className="mx-auto max-w-xl px-6 py-24 text-center">
        <h1 className="text-2xl font-semibold">{t.errorSomethingWrong}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{error.message}</p>
        <button
          onClick={() => {
            router.invalidate();
            reset();
          }}
          className="mt-6 rounded-full bg-primary px-5 py-2 text-sm font-medium text-primary-foreground"
        >
          {t.errorTryAgain}
        </button>
      </div>
    );
  },
  notFoundComponent: () => (
    <div className="mx-auto max-w-xl px-6 py-24 text-center">
      <p className="text-muted-foreground">{BOOK_T.en.notFound}</p>
    </div>
  ),
});

function EnBookPage() {
  const search = Route.useSearch();
  const router = useRouter();
  return (
    <BookPage
      lang="en"
      search={search as BookSearch}
      syncUrl={(next) =>
        router.navigate({
          to: "/book",
          search: next,
          replace: true,
          resetScroll: false,
        })
      }
      homeHref={<BookPageHeaderLinks lang="en" />}
    />
  );
}